import { IModelCapabilitiesSolution as IContenfulSolution } from 'marketing-site/@types/generated/contentful'
import { ReactNode } from 'react'
import { transformMedia } from '../elements/ContentfulMedia'

export interface ISolution {
  icon?: ReactNode
  heading: string
  subheading?: string
  ctaText: string
  ctaUrl: string
}

export function transformSolution({ fields }: IContenfulSolution): ISolution {
  return {
    ...fields,
    icon: fields.icon && transformMedia(fields.icon),
  }
}
